import styled from 'styled-components';

import Divider from '../Divider';

export const AppointmentActionsWrapper = styled.div`
    margin-top: 2.4rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;

    & > div {
        display: flex;
        gap: 1.6rem;
    }

    button {
        flex-grow: 1;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        flex-direction: row;
        gap: 1.6rem;
        button {
            flex-grow: 0;
        }

        & > ${Divider} {
            display: none;
        }
    }
`;
